import PlayerEvent from '../core/events/player.event';
import { logDebugging, logError } from '../log/logger';
import AdManager from './ad.manager';
import * as AdsControllerEvent from './events/ad.controller.events';
import * as AdEvent from '../core/events/ad.events';
import * as POSITIONS from './constants/positions';
import AdException from './errors/ad.exception';
import AdUnit from './jstag/adUnit';
import { SIZES_16_9, SIZES_9_16 } from '../ssp/sspParamsConstants';
import { isMobile } from '../utils/browserUtils';

export default class AdsController {
  constructor(idComponent, adsModel, config, position) {
    this.idComponent = idComponent;
    this.adsModel = adsModel;
    this.config = config || {};
    this.position = position;
    this.eventAdsController = new PlayerEvent('onAdsControllerEvent');
    this.totalAdsByBlock = adsModel.getNumAdsByBlock();
    this.indexCurrentAd = 1;
    this.muted = this.config.muted;
    this.originalAds = Object.assign(this.adsModel.getAds());
  }

  requestAds() {
    const ads = this.adsModel.getAdsToRequest();
    logDebugging('[AdsController] requestAds', ads.length, this.adsModel.getAds());
    return new Promise((resolve) => {
      if (this.checkPosition()) {
        this.dispatchEvent([AdsControllerEvent.AD_ERROR, 'Any position found for this ads block']);
        return;
      }

      Promise.any(ads.map(this.loadAdController.bind(this)))
        .then((ad) => {
          logDebugging('[AdsController] Primera campaña cargada ', ad.cid, ad.name);
          if (!this.callInBackground) {
            // this.dispatchEvent([AdsControllerEvent.FIRST_AD_LOADED, ad]);
            this.setAdControllerSelected(ad.adController);
            this.startController();
            resolve('Cargada primera campaña');
            setTimeout(() => {
              // logDebugging('[AdsController] TIMEOUT 2SEG', this.adsModel);
              resolve('Timeout para cargar campañas');
            }, 5000);
          }
        })
        .catch((error) => {
          logDebugging('[AdsController] No se ha cargado campaña');
          logDebugging('[AdsController]', error);
          resolve('Timeout para cargar campañas');
        });
    });
  }

  loadAdController(ad) {
    const adManager = new AdManager(this.idComponent, ad, this.adsModel.getExtInfo(), this.config);
    this.activateEventsAd(adManager);
    return new Promise((resolve, reject) => {
      if (adManager.isPlayingNow()) {
        reject(new AdException('This ad is now in delivery'));
        return;
      }
      adManager.requestAd().then(
        (adController) => {
          logDebugging('[AdsController] loadAdController ', adController);
          // eslint-disable-next-line no-param-reassign
          ad.adController = adController;
          this.dispatchEvent([AdsControllerEvent.AD_LOADED, ad]);
          resolve(ad);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  activateEventsAd(adManager) {
    adManager.getEvent().subscribe((sender, eventArgs) => {
      const [action, ad] = eventArgs.message;
      switch (action) {
        case AdEvent.AdStarted:
          if (this.indexCurrentAd === 1) {
            this.dispatchEvent([AdsControllerEvent.FIRST_AD_LOADED, ad]);
          }
          this.indexCurrentAd += 1;
          this.dispatchEvent([AdsControllerEvent.AD_PLAY_STARTED]);
          logDebugging(
            '[AdsController] hasAdsInBackgroundToDelivery start',
            this.hasAdsInBackgroundToDelivery(),
          );
          this.checkIfNeedMoreAds();

          break;
        case AdEvent.AdStopped:
        case AdEvent.AdError: {
          this.dispatchEvent([AdsControllerEvent.AD_PLAY_COMPLETED]);
          adManager.removeAdEvents();
          this.getNextAd();
          break;
        }
        case AdEvent.AdShowSkip:
          this.dispatchEvent([AdsControllerEvent.AD_SHOW_SKIP]);
          break;
        case AdEvent.AdPaused:
          this.dispatchEvent([AdsControllerEvent.AD_PAUSED]);
          break;
        case AdEvent.AdPlaying:
          this.dispatchEvent([AdsControllerEvent.AD_RESUME]);
          break;
        default:
          break;
      }
    });
  }

  getNextAd() {
    logDebugging(
      '[AdsController] getNextAd',
      this.adsModel.getItemSelected(),
      this.adsModel.getNumAdsByBlock(),
    );
    if (!this.isBlockCompleted()) {
      const [nextAd] = this.adsModel.getDeliveryAds();
      if (nextAd) {
        this.setAdControllerSelected(nextAd.adController);
        this.startController();
      } else {
        this.loadDisplayController({}).then(
          (ad) => {
            this.setAdControllerSelected(ad.adController);
            this.startController();
            this.dispatchEvent([AdsControllerEvent.AD_PLAY_STARTED, ad]);
          },
          (error) => {
            logDebugging(error);
            // this.indexCurrentAd = 1;
            this.dispatchEvent([AdsControllerEvent.BLOCK_COMPLETED]);
          },
        );
      }
    } else {
      logDebugging(
        '[AdsController] hasAdsInBackgroundToDelivery block_completed',
        this.hasAdsInBackgroundToDelivery(),
      );
      this.checkIfNeedMoreAds();

      // this.indexCurrentAd = 1;
      this.dispatchEvent([AdsControllerEvent.BLOCK_COMPLETED]);
    }
  }

  async playAds() {
    this.indexCurrentAd = 1;

    const [nextAd] = this.adsModel.getDeliveryAds();
    if (!nextAd) {
      await this.requestAds();
    }
    this.getNextAd();
  }

  startController() {
    this.adControllerSelected.start();
    this.adControllerSelected.setVolume(this.config.volume);
    // eslint-disable-next-line no-unused-expressions
    this.muted ? this.adControllerSelected.mute() : this.adControllerSelected.unmute();
  }

  setAdControllerSelected(adController) {
    if (!adController) {
      logError('[AdsController] adControllerSelected is null, get Next');
      this.getNextAd();
    }
    delete this.adControllerSelected;
    this.adControllerSelected = adController;
    this.dispatchEvent([AdsControllerEvent.AD_CHANGED]);
  }

  getEvent() {
    return this.eventAdsController;
  }

  checkPosition() {
    const positions = [POSITIONS.PREROLL, POSITIONS.POSROLL, POSITIONS.MIDROLL];
    return positions.indexOf(this.adsModel.getPosition()) === -1;
  }

  hasAdsInBackgroundToDelivery() {
    return this.adsModel.getDeliveryAds().length > 0;
  }

  checkIfNeedMoreAds() {
    if (!this.hasAdsInBackgroundToDelivery() && !this.isBlockCompleted()) {
      // this.adsModel.resetAds();
      this.callInBackground = true;
      // this.requestAds();
      this.dispatchEvent([AdsControllerEvent.SEARCH_AD]);
    }
  }

  isBlockCompleted() {
    return !(this.indexCurrentAd <= this.totalAdsByBlock);
  }

  loadDisplayController(ad) {
    const adManager = new AdManager(this.idComponent, ad);
    this.activateEventsAd(adManager);
    return new Promise((resolve, reject) => {
      if (adManager.isPlayingNow()) {
        reject(new AdException('This ad is now in delivery'));
        return;
      }

      const formatSizes = this.config.format === 'vertical' ? SIZES_9_16.MREC : SIZES_16_9.MREC;
      const adunit = new AdUnit(this.config)
        .setDivId('display-preroll')
        .setSizes(isMobile() ? formatSizes.MOBILE : formatSizes.DESKTOP)
        .build();
      if ((!adunit.tappxKey.mweb && !adunit.tappxKey.desktop) || !adunit.endpoint) {
        reject(new AdException('AdUnit Params are empty', '201'));
        return;
      }
      const videoData = { itemContent: this.itemContent };
      // console.time('adsControllerDisplay');
      adManager.requestDisplay(videoData, adunit).then(
        (adController) => {
          // console.timeEnd('adsControllerDisplay');
          logDebugging('[AdsController] loadAdController ', adController);
          // eslint-disable-next-line no-param-reassign
          ad.adController = adController;
          resolve(ad);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  addNewAds(blockAd) {
    this.adsModel.addNewAds(blockAd);
    this.requestAds();
  }

  resize() {
    this.adControllerSelected?.resize();
  }

  dispatchEvent(arg) {
    this.eventAdsController.fire(this, { message: arg });
  }
}
